import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ApplicationState } from 'store';
import { ConlicitasegState } from 'store/modules/conlicitaseg_store/types';
import { setFormQuote } from 'store/modules/conlicitaseg_store/actions';
import InsuranceStepIndicator from 'components/atoms/insurance_step_indicator';
import QuoteGuaranteeHeader from 'components/atoms/quote_guarantee_header';
import LegalBondNotice from 'components/atoms/legal_bond_notice';
import useQuoteFlow from 'hooks/useQuoteFlow';
import { getInsuranceReasonOptions } from 'services/conlicitaseg';
import { LabelItem } from './styles';

const reasonOptions = getInsuranceReasonOptions();

const ReasonsNewInsurance: React.FC = () => {
  const [reason, setReason] = useState<string>('');
  const dispatch = useDispatch();
  const history = useHistory();
  const { guarantee_type, request } = useSelector<ApplicationState, ConlicitasegState>(
    (state) => state.session.conlicitaseg,
  );
  const { config, pathFor, nextPathFor, stepIndicatorProps } = useQuoteFlow();

  const { reasonPageWithNotices } = config;
  const hasReasonStep = !!config.reasonStepTitle;
  const showLicitante = hasReasonStep && guarantee_type !== 'execucao';
  const options = showLicitante
    ? reasonOptions
    : reasonOptions.filter((option) => option.value !== 'Licitante');
  const isLoadingFidelizeData = !!request?.get_fidelize_bidding_guarantee?.loading;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (reason) {
      dispatch(setFormQuote({ type_warranty_id: reason }));
      history.push(nextPathFor('motivo', reason) || pathFor('tomador'));
    }
  };

  return (
    <div className="page-container">
      <div className="container-fluid big-resolutions py-5 px-md-5">
        <div className="row justify-content-center mt-5">
          <div className="col-12 mx-auto">
            <div className="row align-items-stretch">
              <div className={hasReasonStep ? 'col-md-9' : 'col-12'}>
                {reasonPageWithNotices && <QuoteGuaranteeHeader title="Seguro Garantia" />}
                <div className="shadow-sm p-4 bg-white rounded">
                  {reasonPageWithNotices ? (
                    <h3 className="mb-4">Selecione o tipo de garantia</h3>
                  ) : (
                    <h4 className="mb-4">Qual o motivo do seguro garantia?</h4>
                  )}
                  <div className="row justify-content-center">
                    <div className="col">
                      <form onSubmit={handleSubmit}>
                        <div className="row">
                          {options.map((option, idx) => (
                            <React.Fragment key={option.value}>
                              <div
                                className={`col-12 ${
                                  reasonPageWithNotices ? 'col-md-4' : 'col-md-6'
                                } mb-3`}
                              >
                                <LabelItem
                                  className="form-check px-5 py-3 border rounded bg-white h-100 mb-0"
                                  htmlFor={`reason-${idx}`}
                                >
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="reason"
                                    id={`reason-${idx}`}
                                    value={option.value}
                                    checked={reason === option.value}
                                    onChange={() => setReason(option.value)}
                                  />
                                  <div className="form-check-label pl-2">{option.text}</div>
                                </LabelItem>
                              </div>
                              {/* Licitante sozinho na primeira linha */}
                              {reasonPageWithNotices && option.value === 'Licitante' && (
                                <div className="w-100" />
                              )}
                            </React.Fragment>
                          ))}
                        </div>
                        {reasonPageWithNotices && <LegalBondNotice />}
                        <div className="d-flex justify-content-end mt-3">
                          <button
                            type="button"
                            className="btn btn-outline-secondary"
                            onClick={() => history.push('/conlicitaseg')}
                          >
                            Cancelar
                          </button>
                          <button
                            type="submit"
                            className="btn btn-primary ml-2"
                            disabled={!reason || isLoadingFidelizeData}
                          >
                            Continuar
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              {hasReasonStep && (
                <div className="col-md-3 d-none d-md-block">
                  <InsuranceStepIndicator {...stepIndicatorProps('motivo', reason)} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReasonsNewInsurance;
